/* EG Collections — UX (apply config allow/order, dropdown overlay behaviour, clear filters UI) */

// Adds/removes .eg-is-stuck when a sticky element becomes stuck (shadow control)
function egBindStickyShadow(el) {
  if (!el || el.__egStickyShadowBound) return;
  el.__egStickyShadowBound = true;

  function getStickyTopPx() {
    try {
      var cs = window.getComputedStyle ? getComputedStyle(el) : null;
      var top = cs ? cs.top : "0px";
      var n = parseFloat(top);
      return isNaN(n) ? 0 : n;
    } catch (e) {
      return 0;
    }
  }

  function computeStartY() {
    var topPx = getStickyTopPx();
    var rect = el.getBoundingClientRect();
    return (rect.top + window.pageYOffset) - topPx;
  }

  var startY = computeStartY();

  function onScroll() {
    var topPx = getStickyTopPx();
    var rectTop = el.getBoundingClientRect().top;

    // Consider it "stuck" when it is clamped to the sticky top (within 1px tolerance)
    var stuck = rectTop <= (topPx + 1);
    if (el.classList) el.classList.toggle("eg-is-stuck", stuck);
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", function () {
    startY = computeStartY();
    onScroll();
  });

  onScroll();
}

function egBuildPrettySearch(sp) {
  sp = sp || new URLSearchParams(window.location.search || "");

  var cfg = window.EG_URL_PRETTY || {};
  var facetAliases = cfg.facetParamAliases || {};
  var tagAliases = cfg.tagParamAliases || {};
  var useSuffix = !!cfg.tagValueUseSuffix;

  var out = new URLSearchParams();

  sp.forEach(function (v, k) {
    if (!k) return;

    // EG numeric range sliders: rewrite eg_range_* -> slider key (length/width/thickness/area)
    if (k.indexOf("eg_range_") === 0) {
      var sliders = window.EG_NUMERIC_TAG_SLIDERS || {};
      var prettyKey = null;

      for (var rk in sliders) {
        if (!sliders.hasOwnProperty(rk)) continue;
        var sc = sliders[rk];
        if (sc && String(sc.param || "") === k) { prettyKey = String(rk); break; }
      }

      out.append(prettyKey || k, v);
      return;
    }

    // KEEP all other non-filter params (page, eg_sort, eg_show_legacy, etc.)
    // The only "EG" params we rewrite are eg_tag_* (below) and eg_range_* (above).
    if (k.indexOf("filter.") !== 0 && k.indexOf("eg_tag_") !== 0) {
      out.append(k, v);
      return;
    }

    // Shopify facets -> alias if configured
    if (k.indexOf("filter.") === 0) {
      var alias = facetAliases[k] || null;
      out.append(alias || k, v);
      return;
    }

    // EG tags -> alias if configured
    if (k.indexOf("eg_tag_") === 0) {
      var groupKey = k.replace("eg_tag_", "");
      var alias2 = tagAliases[groupKey] || null;

      var val = String(v || "");

      if (useSuffix) {
        if (val.indexOf("__") !== -1) {
          val = val.split("__").pop();
        } else if (val.indexOf("_") !== -1) {
          val = val.split("_").pop();
        }
      }

      out.append(alias2 || groupKey, val);
      return;
    }
  });

  return out.toString();
}

function egApplyPrettyUrlToAddressBar() {
  try {
    var sp = new URLSearchParams(window.location.search || "");
    var pretty = egBuildPrettySearch(sp);
    var base = window.location.pathname + (pretty ? ("?" + pretty) : "") + (window.location.hash || "");
    history.replaceState({}, "", base);
  } catch (e) {}
}

// Apply pretty URL once on load (after other scripts have finished their initial URL work)
(function () {
  if (window.__egPrettyUrlBooted) return;
  window.__egPrettyUrlBooted = true;

  function run() {
    try {
      if (typeof egApplyPrettyUrlToAddressBar === "function") {
        egApplyPrettyUrlToAddressBar();
      }
    } catch (e) {}
  }

  // Run after all scripts have settled
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(run, 0);
    });
  } else {
    setTimeout(run, 0);
  }
})();

function getRuleForRoot(root) {
  var cfg = window.EG_COLLECTION_FILTERS;
  if (!cfg || !root) return null;

  var ds = root.dataset || {};
  var handle = String(ds.egCollection || "");
  var template = String(ds.egTemplate || ""); // template_suffix: "brand", "fancy-brand"

  // 1) Collection-specific rule wins
  if (cfg.collections && handle && cfg.collections[handle]) {
    return cfg.collections[handle];
  }

  // 2) Template-specific rule
  if (cfg.templates && template && cfg.templates[template]) {
    return cfg.templates[template];
  }

  // 3) Fallback
  return cfg.default || null;
}

function applyCollectionFilterConfig(root) {
  var cfg = window.EG_COLLECTION_FILTERS;
  if (!cfg || !root) return;

  var rule = (typeof getRuleForRoot === "function") ? getRuleForRoot(root) : null;
  rule = rule || cfg.default || null;

  var allowArr = (rule && rule.allow) ? rule.allow : [];
  var allow = {};
  for (var i = 0; i < allowArr.length; i++) allow[String(allowArr[i])] = 1;

  var groups = root.querySelectorAll(".eg-filter-group[data-eg-filter-key]");
  for (var g = 0; g < groups.length; g++) {
    var group = groups[g];
    var key = String(group.getAttribute("data-eg-filter-key") || "");

    // Never hide the Clear button container
    if (group.querySelector("[data-eg-clear-filters]")) {
      group.style.display = "";
      continue;
    }

    // If allow[] empty => show all
    var ok = allowArr.length ? !!allow[key] : true;
    group.style.display = ok ? "" : "none";
  }

  // Ordering
  if (rule && rule.order && rule.order.length) {
    var orderIndex = {};
    for (var j = 0; j < rule.order.length; j++) orderIndex[String(rule.order[j])] = j;

    // Convert NodeList -> array
    var arr = [];
    for (var k = 0; k < groups.length; k++) arr.push(groups[k]);

    arr.sort(function (a, b) {
      var ak = String(a.getAttribute("data-eg-filter-key") || "");
      var bk = String(b.getAttribute("data-eg-filter-key") || "");
      var ai = orderIndex.hasOwnProperty(ak) ? orderIndex[ak] : 999;
      var bi = orderIndex.hasOwnProperty(bk) ? orderIndex[bk] : 999;
      return ai - bi;
    });

    var scroll = root.querySelector(".eg-filterbar-scroll") || root;
    for (var z = 0; z < arr.length; z++) scroll.appendChild(arr[z]);
  }
}

function egApplyFilterOptionOrdering(root) {
  if (!root) return;
  if (typeof getRuleForRoot !== "function") return;

  var rule = getRuleForRoot(root);
  var map = (rule && rule.valueOrder) ? rule.valueOrder : null;
  map = map || {};

  function norm(s) {
    return String(s || "").trim().toLowerCase();
  }

  function getLabelText(labelEl) {
    if (!labelEl) return "";
    var t =
      labelEl.querySelector(".eg-filter-option-label") ||
      labelEl.querySelector(".eg-filter-option-text") ||
      labelEl;
    return String(t.textContent || "").trim();
  }

  function getChildFilterKeyFromSection(sectionEl) {
    // For tagset sections, the checkbox keeps the original child group key.
    // input[data-eg-tag-group="stitched_edges"] => filter key is "tag.stitched_edges"
    if (!sectionEl) return "";
    var cb = sectionEl.querySelector('input[type="checkbox"][data-eg-tag-group]');
    if (!cb) return "";
    var gk = String(cb.getAttribute("data-eg-tag-group") || cb.dataset.egTagGroup || "").trim();
    if (!gk) return "";
    return "tag." + gk;
  }

  function reorderLabelsWithinContainer(containerEl, filterKeyForThisList) {
    if (!containerEl) return;

    var labels = Array.prototype.slice.call(containerEl.querySelectorAll(":scope > label.eg-filter-option"));
    if (!labels.length) return;

    var manual = Array.isArray(map[filterKeyForThisList]) ? map[filterKeyForThisList] : null;
    var manualNorm = manual ? manual.map(norm) : null;

    var entries = labels.map(function (lab, idx) {
      var txt = getLabelText(lab);
      var n = norm(txt);
      var manualIndex = -1;

      if (manualNorm) manualIndex = manualNorm.indexOf(n);

      return {
        el: lab,
        textNorm: n,
        idx: idx,
        manualIndex: manualIndex
      };
    });

    entries.sort(function (a, b) {
      var ai = a.manualIndex;
      var bi = b.manualIndex;

      var aHas = ai !== -1;
      var bHas = bi !== -1;

      if (aHas && bHas) return ai - bi;
      if (aHas && !bHas) return -1;
      if (!aHas && bHas) return 1;

      var c = a.textNorm.localeCompare(b.textNorm);
      if (c !== 0) return c;
      return a.idx - b.idx;
    });

    for (var i = 0; i < entries.length; i++) {
      containerEl.appendChild(entries[i].el);
    }
  }

  var groups = root.querySelectorAll(".eg-filter-group[data-eg-filter-key]");
  for (var i = 0; i < groups.length; i++) {
    var g = groups[i];
    var groupKey = String(g.getAttribute("data-eg-filter-key") || "");
    if (!groupKey) continue;

    var panel = g.__egPanel || g.querySelector(".eg-filter-options");
    if (!panel) continue;

    // If this is a tagset/grouped dropdown, reorder inside each subgroup section
    var sections = panel.querySelectorAll(".eg-filter-subgroup");
    if (sections && sections.length) {
      for (var s = 0; s < sections.length; s++) {
        var section = sections[s];

        // IMPORTANT: reorder ONLY labels that are direct children of the section
        // (keeps the subtitle in place and prevents mixing between sections)
        var filterKey = getChildFilterKeyFromSection(section) || groupKey;

        reorderLabelsWithinContainer(section, filterKey);
      }
      continue;
    }

    // Normal (non-tagset) groups: reorder direct labels in the panel
    reorderLabelsWithinContainer(panel, groupKey);
  }
}

function bindMobileFilterAccordion(root) {
  if (!root || root.__egMobileAccordionBound) return;
  root.__egMobileAccordionBound = true;

  function isMobile() {
    try {
      return window.matchMedia && window.matchMedia("(max-width: 999px)").matches;
    } catch (e) {
      return false;
    }
  }

  function closeAllExcept(exceptGroup) {
    var groups = root.querySelectorAll(".eg-filter-group");
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      if (exceptGroup && g === exceptGroup) continue;

      g.classList.remove("is-open");
      var ttl = g.querySelector(".eg-filter-title");
      if (ttl) ttl.setAttribute("aria-expanded", "false");
    }
  }

  root.addEventListener("click", function (e) {
    if (!isMobile()) return;

    var title = e.target && e.target.closest ? e.target.closest(".eg-filter-title") : null;
    if (!title || !root.contains(title)) return;

    var group = title.closest(".eg-filter-group");
    if (!group) return;

    // Prevent desktop overlay handler patterns from triggering
    e.preventDefault();
    e.stopPropagation();

    var isOpen = group.classList.contains("is-open");

    if (!isOpen) {
      group.classList.add("is-open");
      title.setAttribute("aria-expanded", "true");
    } else {
      group.classList.remove("is-open");
      title.setAttribute("aria-expanded", "false");
    }
  });

  // When the drawer closes, collapse everything (keeps state tidy)
  document.addEventListener("click", function () {
    if (!isMobile()) return;
    if (!document.documentElement.classList.contains("eg-mobile-filters-open")) {
      closeAllExcept(null);
    }
  });
}

function bindDropdownOverlay(root) {
  if (!root || root.__egDropdownBound) return;
  root.__egDropdownBound = true;

  // MOBILE: prevent theme scripts from handling EG filter OPTION clicks
// (theme.min.js is throwing on checkbox clicks, breaking interaction)
root.addEventListener("click", function (e) {
  try {
    if (!window.matchMedia || !window.matchMedia("(max-width: 999px)").matches) return;

    var t = e.target;

    // Any tap/click inside an EG option row (label/input/button) should not bubble to theme
    var inEgOption =
      (t && t.closest && (
        t.closest("label.eg-filter-option") ||
        t.closest(".eg-filter-options") ||
        t.closest(".eg-range-wrap") ||
        t.closest(".eg-price-range") ||
        t.closest(".eg-mobile-filters-header") ||
        t.closest(".eg-mobile-filters-footer")
      ));

      if (!inEgOption) return;

      // Allow drawer header/footer controls to bubble to document handlers (Clear, Close, See products)
      if (t && t.closest && (
        t.closest("[data-eg-clear-filters]") ||
        t.closest("[data-eg-mobile-filters-close]") ||
        t.closest("[data-eg-mobile-see-products]")
      )) {
        return;
      }

      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  } catch (err) {}
}, false);

// Mobile uses accordion inside the bottom sheet (no overlay teleport)
try {
  if (window.matchMedia && window.matchMedia("(max-width: 999px)").matches) {
    if (typeof bindMobileFilterAccordion === "function") bindMobileFilterAccordion(root);

    // IMPORTANT: still bind Shopify price_range slider on mobile
    try { egBindPriceRangeSlider(root); } catch (e2) {}

    return;
  }
} catch (e) {}

  const overlay = root.querySelector("[data-eg-filter-overlay]");
  if (!overlay) return;

  let openGroup = null;

    // ----------------------------
  // Per-filter search (>= 11 options)
  // ----------------------------

  function egNormalizeSearchText(s) {
    return String(s || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();
  }

  function egFilterOptionLabelText(labelEl) {
    if (!labelEl) return "";
    var t = "";

    var main = labelEl.querySelector(".eg-filter-option-label");
    if (main) t = main.textContent || "";
    else t = labelEl.textContent || "";

    // Remove "(123)" count text if present
    t = String(t).replace(/\(\s*\d+\s*\)/g, "");
    return egNormalizeSearchText(t);
  }

  function egApplySearchToScope(scopeEl, q) {
    if (!scopeEl) return;

    var query = egNormalizeSearchText(q);
    var labels = scopeEl.querySelectorAll("label.eg-filter-option");
    if (!labels || !labels.length) return;

    for (var i = 0; i < labels.length; i++) {
      var lab = labels[i];
      var txt = egFilterOptionLabelText(lab);

      var ok = !query || (txt.indexOf(query) !== -1);
      lab.style.display = ok ? "" : "none";
    }
  }

  function egEnsureSearchInputForScope(scopeEl, insertAfterEl) {
    if (!scopeEl) return;

    // Only for checkbox lists (ignore sliders)
    if (scopeEl.querySelector(".eg-range-wrap")) return;

    var labels = scopeEl.querySelectorAll("label.eg-filter-option");
    if (!labels || labels.length <= 10) return;

    if (scopeEl.querySelector(".eg-filter-search-wrap")) return;

    var wrap = document.createElement("div");
    wrap.className = "eg-filter-search-wrap";

    // Inject site-owned search icon (from Liquid template)
    var iconHost = document.getElementById("eg-icon-templates");
    var iconTpl = iconHost ? iconHost.querySelector(".eg-icon--search") : null;
    if (iconTpl) {
      wrap.appendChild(iconTpl.cloneNode(true));
    }

    var input = document.createElement("input");
    input.type = "search";
    input.className = "eg-filter-search";
    input.placeholder = "Search...";
    input.autocomplete = "off";
    input.spellcheck = false;

    wrap.appendChild(input);

    if (insertAfterEl && insertAfterEl.parentNode) {
      insertAfterEl.parentNode.insertBefore(wrap, insertAfterEl.nextSibling);
    } else {
      scopeEl.insertBefore(wrap, scopeEl.firstChild);
    }

    input.addEventListener("input", function () {
      egApplySearchToScope(scopeEl, input.value);
    });

    // Clear on Esc
    input.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        input.value = "";
        egApplySearchToScope(scopeEl, "");
      }
    });
  }

  function egEnsureSearchUIForGroup(group) {
    if (!group) return;

    var panel = group.__egPanel || group.querySelector(".eg-filter-options");
    if (!panel) return;

    // Tagset: add search per subgroup (only filters that subgroup)
    var subgroups = panel.querySelectorAll(".eg-filter-subgroup");
    if (subgroups && subgroups.length) {
      for (var i = 0; i < subgroups.length; i++) {
        var sg = subgroups[i];
        var subtitle = sg.querySelector(".eg-filter-subtitle") || null;
        egEnsureSearchInputForScope(sg, subtitle);
      }
      return;
    }

    // Normal group: one search for the whole panel
    egEnsureSearchInputForScope(panel, null);
  }


  function ensurePanelId(group) {
    const panel = group.__egPanel || group.querySelector(".eg-filter-options");
    if (!panel) return null;

    if (!panel.id) {
      panel.id = "eg-filter-panel-" + Math.random().toString(36).slice(2, 9);
    }
    return panel.id;
  }

  function setupA11y(group) {
    const trigger = group.querySelector(".eg-filter-title");
    if (!trigger) return;

    trigger.setAttribute("role", "button");
    trigger.setAttribute("tabindex", "0");
    trigger.setAttribute("aria-expanded", "false");

    const panelId = ensurePanelId(group);
    if (panelId) trigger.setAttribute("aria-controls", panelId);

    const panel = group.__egPanel || group.querySelector(".eg-filter-options");
    if (panel) panel.setAttribute("aria-hidden", "true");
  }

  root.querySelectorAll(".eg-filter-group").forEach(setupA11y);

  function setExpanded(group, isOpen) {
    const trigger = group.querySelector(".eg-filter-title");
    if (trigger) trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");

    const panel = group.__egPanel || group.querySelector(".eg-filter-options");
    if (panel) panel.setAttribute("aria-hidden", isOpen ? "false" : "true");
  }

  function ensureCountEl(group) {
    let el = group.querySelector(".eg-filter-count");
    if (!el) {
      el = document.createElement("span");
      el.className = "eg-filter-count";
      group.querySelector(".eg-filter-title")?.appendChild(el);
    }
    return el;
  }

  function ensureRangeClearBtn(group) {
    var title = group.querySelector(".eg-filter-title");
    if (!title) return null;

    var btn = title.querySelector(".eg-filter-clear-one");
    if (!btn) {
      btn = document.createElement("button");
      btn.type = "button";
      btn.className = "eg-filter-clear-one";
      btn.setAttribute("aria-label", "Clear filter");
      btn.textContent = "×";
      title.appendChild(btn);
    }
    return btn;
  }

  function hideRangeClearBtn(group) {
    var title = group.querySelector(".eg-filter-title");
    if (!title) return;
    var btn = title.querySelector(".eg-filter-clear-one");
    if (btn) btn.style.display = "none";
  }

  function updateAllCounts() {
    root.querySelectorAll(".eg-filter-group").forEach(group => {
      const countEl = ensureCountEl(group);

      // We only want the active styling (.has-selection), not the numeric counter badge
      countEl.textContent = "";
      countEl.style.display = "none";

      // 1) Checkbox groups (existing behaviour)
      var panelX = group.__egPanel || group.querySelector(".eg-filter-options") || group;
      const checked = panelX.querySelectorAll('input[type="checkbox"]:checked').length;
      if (checked > 0) {
        // Keep active styling only (no numeric badge)
        countEl.textContent = "";
        countEl.style.display = "none";
        group.classList.toggle("has-selection", true);
        return;
      }

      // 2) Slider/range groups (NEW behaviour)
      // Range metadata lives on the slider UI node (eg-range-wrap), not on the group.
      var panel0 = group.__egPanel || group.querySelector(".eg-filter-options") || group;
      var rangeHost = panel0.querySelector("[data-eg-range-param]") || group.querySelector("[data-eg-range-param]");

      var rangeParam = rangeHost ? (rangeHost.getAttribute("data-eg-range-param") || "") : "";
      if (rangeParam) {
        var sp = new URLSearchParams(window.location.search || "");
        var v = String(sp.get(rangeParam) || "");
        if (!v) {
          // support pretty key (?length=...) for this rangeParam (eg_range_length)
          var sliders = window.EG_NUMERIC_TAG_SLIDERS || {};
          for (var rk in sliders) {
            if (!sliders.hasOwnProperty(rk)) continue;
            var sc = sliders[rk];
            if (sc && String(sc.param || "") === String(rangeParam)) {
              v = String(sp.get(String(rk)) || "");
              break;
            }
          }
        }
        var unit = rangeHost.getAttribute("data-eg-range-unit") || "";

        // Only show a pill when it's not the "full range"
        var min0 = parseFloat(rangeHost.getAttribute("data-eg-range-min") || "");
        var max0 = parseFloat(rangeHost.getAttribute("data-eg-range-max") || "");
        var show = false;

        if (v) {
          // v format: "a-b"
          var mm = (typeof egParseMinMaxFromRangeValue === "function") ? egParseMinMaxFromRangeValue(v) : null;
          var a = mm ? mm.min : NaN;
          var b = mm ? mm.max : NaN;
          if (!isNaN(a) && !isNaN(b) && !isNaN(min0) && !isNaN(max0)) {
            show = (a !== min0 || b !== max0);
          } else {
            show = true;
          }
        }

        if (show) {
          // Do NOT use the dropdown label count badge for sliders.
          // Sliders should appear only in the applied pills toolbar.
          countEl.textContent = "";
          countEl.style.display = "none";
          group.classList.toggle("has-selection", true);
          return;
        }
      }

      // 3) Price range (Shopify) active styling
      var spP = new URLSearchParams(window.location.search || "");
      var cfgPP = window.EG_URL_PRETTY || {};
      var facetAliasesPP = cfgPP.facetParamAliases || {};

      function egGet1BothPrice(spx, longKey) {
        var a = spx.get(longKey);
        if (a) return a;
        var alias = facetAliasesPP[longKey];
        return alias ? (spx.get(String(alias)) || "") : "";
      }

      if (egGet1BothPrice(spP, "filter.v.price.gte") || egGet1BothPrice(spP, "filter.v.price.lte")) {
        var panelP = group.__egPanel || group.querySelector(".eg-filter-options") || group;
        if (panelP && panelP.querySelector && panelP.querySelector(".eg-price-range")) {
          group.classList.toggle("has-selection", true);
          return;
        }
      }

      // default: no selection
      countEl.textContent = "";
      countEl.style.display = "none";
      group.classList.toggle("has-selection", false);
    });
  }

    // expose for other modules (init / ajax swap)
    root.__egUpdateAllCounts = updateAllCounts;
    egBindPriceRangeSlider(root);

    if (!window.__egRangeClearClickBound) {
    window.__egRangeClearClickBound = true;

    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest(".eg-filter-clear-one");
      if (!btn) return;

      var group = btn.closest && btn.closest(".eg-filter-group");
      if (!group) return;

      var panel = group.__egPanel || group.querySelector(".eg-filter-options") || group;
      var host = panel.querySelector("[data-eg-range-param]");
      var param = host ? (host.getAttribute("data-eg-range-param") || "") : "";
      if (!param) return;

      e.preventDefault();
      e.stopPropagation();

      // Clear the range param
      if (typeof egSetUrlParamNoReload === "function") {
        egSetUrlParamNoReload(param, "");
      } else {
        var u = new URL(window.location.href);
        u.searchParams.delete(param);
        history.replaceState({}, "", u.toString());
        egApplyPrettyUrlToAddressBar();
      }

      // Refresh render + UI
      var root0 = document.getElementById("eg-collection-filters") || document.querySelector("#eg-collection-filters");
      if (root0 && typeof root0.__egClientRenderRefresh === "function") root0.__egClientRenderRefresh();
      if (root0 && root0.__egUpdateAllCounts) root0.__egUpdateAllCounts();
      if (root0 && root0.__egUpdateClearVisibility) root0.__egUpdateClearVisibility();
    }, true);
  }

  function closeOpen() {
    if (!openGroup) return;

    const panel = openGroup.__egPanel;
    if (panel) panel.style.display = "none";

    openGroup.classList.remove("is-open");
    setExpanded(openGroup, false);
    openGroup = null;

    root.__egOpenFilterKey = "";
  }

  function positionPanel(group) {
    const trigger = group.querySelector(".eg-filter-title");
    const panel = group.__egPanel;
    if (!trigger || !panel) return;

    const rootRect = root.getBoundingClientRect();
    const trigRect = trigger.getBoundingClientRect();

    const left0 = Math.round(trigRect.left - rootRect.left);
    const top = Math.round(trigRect.bottom - rootRect.top + 8);

    panel.style.top = top + "px";

    const maxLeft = Math.max(8, Math.round(rootRect.width - panel.offsetWidth - 8));
    const clampedLeft = Math.min(Math.max(8, left0), maxLeft);
    panel.style.left = clampedLeft + "px";
  }

  function openGroupPanel(group) {
    if (!group) return;

    if (openGroup && openGroup !== group) closeOpen();

    root.__egOpenFilterKey = group.getAttribute("data-eg-filter-key") || "";

    const panel = group.__egPanel || group.querySelector(".eg-filter-options");
    if (!panel) return;

    if (!group.__egPanel) {
      group.__egPanel = panel;
      overlay.appendChild(panel);

      panel.style.position = "absolute";
      panel.style.display = "none";
      panel.style.margin = "0";
    }

    panel.addEventListener("click", (e) => { e.stopPropagation(); });

    openGroup = group;
    group.classList.add("is-open");
    setExpanded(group, true);

    const movedPanel = group.__egPanel;
    movedPanel.style.display = "block";

    // Build search UI for long lists (per group / per subgroup)
    egEnsureSearchUIForGroup(group);

    // Always reset filtering when opening (avoid "missing options" confusion)
    var searchInputs = movedPanel.querySelectorAll(".eg-filter-search");
    for (var si = 0; si < searchInputs.length; si++) {
      searchInputs[si].value = "";
    }
    // Reset search when opening (avoid "missing options" confusion)
    var subgroups2 = movedPanel.querySelectorAll(".eg-filter-subgroup");

    if (subgroups2 && subgroups2.length) {
      // Tagset panel: reset ONLY the subgroups
      for (var s2 = 0; s2 < subgroups2.length; s2++) {
        egApplySearchToScope(subgroups2[s2], "");
      }
    } else {
      // Normal panel: reset the panel scope
      egApplySearchToScope(movedPanel, "");
    }

    positionPanel(group);
  }

  root.addEventListener("click", (e) => {
    const trigger = e.target.closest(".eg-filter-title");
    if (!trigger) return;

    // Block theme dropdown/disclosure scripts from handling our filter titles
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    const group = trigger.closest(".eg-filter-group");
    if (!group) return;

    if (openGroup === group) closeOpen();
    else openGroupPanel(group);
  }, true);

  root.addEventListener("keydown", (e) => {
    const trigger = e.target.closest(".eg-filter-title");
    if (!trigger) return;

    const key = e.key;
    if (key !== "Enter" && key !== " " && key !== "Spacebar") return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    const group = trigger.closest(".eg-filter-group");
    if (!group) return;

    if (openGroup === group) closeOpen();
    else openGroupPanel(group);
  });

  document.addEventListener("click", (e) => {
    if (!openGroup) return;

    const panel = openGroup.__egPanel;
    const clickedTrigger = e.target.closest(".eg-filter-title");
    const clickedInsidePanel = panel && panel.contains(e.target);

    if (clickedInsidePanel) return;
    if (clickedTrigger) return;

    closeOpen();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeOpen();
  });

  window.addEventListener("resize", () => {
    if (openGroup) positionPanel(openGroup);
  });

  window.addEventListener("scroll", () => {
    if (openGroup) positionPanel(openGroup);
  }, true);

  root.addEventListener("change", (e) => {
    updateAllCounts();

    // IMPORTANT:
    // For checkbox changes that trigger navigation (Shopify facets + EG tags),
    // do NOT recompute counts here. Navigation will swap HTML and then update
    // counts once in egAjaxNavigateCollection().
    const t = e.target;
    const isShopifyFacet = !!(t && t.closest && t.closest('input[type="checkbox"][data-filter-key]'));
    const isEgTag = !!(t && t.closest && t.closest('input[type="checkbox"][data-eg-kind="tag"]'));

    if (isShopifyFacet || isEgTag) return;

    // For any other non-navigating changes, keep counts in sync.
    if (typeof egUpdateEgTagGroupCountsAndDisabledFromLite === "function") {
      egUpdateEgTagGroupCountsAndDisabledFromLite(root);
    }
  });

  function refreshDropdownAfterSwap() {
    closeOpen();
    root.__egOpenFilterKey = "";

    root.querySelectorAll(".eg-filter-group").forEach(g => {
      g.__egPanel = null;
      g.classList.remove("is-open");
      setExpanded(g, false);
    });

    root.querySelectorAll(".eg-filter-options").forEach(panel => {
      panel.style.display = "none";
      panel.style.margin = "0";
    });

    root.querySelectorAll(".eg-filter-group").forEach(setupA11y);
    updateAllCounts();
  }

  root.__egDropdownRefresh = refreshDropdownAfterSwap;

  // Sticky shadow for the filter bar (only once)
  egBindStickyShadow(root);

  updateAllCounts();

  function egBindPriceRangeSlider(root) {
    if (!root || root.__egPriceRangeBound) return;
    root.__egPriceRangeBound = true;

    // Find all Shopify price_range blocks rendered by Liquid
    var blocks = root.querySelectorAll(".eg-price-range");
    if (!blocks || !blocks.length) return;

    for (var i = 0; i < blocks.length; i++) {
      (function (wrap) {
        var minInput = wrap.querySelector("input[data-eg-price-min]");
        var maxInput = wrap.querySelector("input[data-eg-price-max]");
        var applyBtn = wrap.querySelector("[data-eg-price-apply]");
        if (!minInput || !maxInput || !applyBtn) return;

        // --- Rebuild Price layout to match Dimensions pattern ---
        // Label ABOVE inputs: "Price (£)"
        if (!wrap.querySelector(".eg-price-label")) {
          var labelEl = document.createElement("div");
          labelEl.className = "eg-filter-subtitle eg-price-label";
          labelEl.textContent = "Price (£)";
          wrap.insertBefore(labelEl, wrap.firstChild);
        }

        // Hide existing Min/Max labels (we keep the inputs)
        var oldLabels = wrap.querySelectorAll("label");
        for (var i = 0; i < oldLabels.length; i++) {
          oldLabels[i].style.display = "none";
        }

        // Build inputs row if not already done
        if (!wrap.querySelector(".eg-range-inputs")) {
          var inputsRow = document.createElement("div");
          inputsRow.className = "eg-range-inputs eg-price-range-inputs";

          // Reuse the same classes Dimensions uses
          minInput.classList.add("eg-range-min");
          maxInput.classList.add("eg-range-max");

          var dash = document.createElement("span");
          dash.className = "eg-range-dash";
          dash.textContent = "–";

          // Move inputs into the row (preserves listeners)
          inputsRow.appendChild(minInput);
          inputsRow.appendChild(dash);
          inputsRow.appendChild(maxInput);

          // Insert inputs row directly after the Price label
          var priceLabel = wrap.querySelector(".eg-price-label");
          wrap.insertBefore(inputsRow, priceLabel.nextSibling);
        }

        // Apply button not needed now we auto-apply on slider release
        applyBtn.style.display = "none";

        var PRICE_FACTOR = 100; // Shopify price_range uses minor units (pence)

        // noUiSlider host
        var sliderHost = wrap.querySelector(".eg-price-range-slider");
        if (!sliderHost) {
          sliderHost = document.createElement("div");
          sliderHost.className = "eg-price-range-slider";
          // Insert before Apply button
          wrap.insertBefore(sliderHost, applyBtn);
        }

        // Compute bounds (Shopify gives pence)
        var minBoundCents = 0;

        var maxBoundCents = parseFloat(String(maxInput.getAttribute("placeholder") || "").replace(/[^\d.]/g, ""));
        if (isNaN(maxBoundCents) || maxBoundCents <= 0) {
          maxBoundCents = parseFloat(String(maxInput.value || "").replace(/[^\d.]/g, ""));
        }
        if (isNaN(maxBoundCents) || maxBoundCents <= 0) return;

        // Slider works in pounds
        var minBound = minBoundCents / PRICE_FACTOR;
        var maxBound = maxBoundCents / PRICE_FACTOR;

        // Read pounds from inputs (user-facing)
        function readPoundsOr(el, fallback) {
          var v = parseFloat(String(el.value || "").replace(/[^\d.]/g, ""));
          return isNaN(v) ? fallback : v;
        }

        // Start values: Shopify inputs initially contain pence from Liquid/URL → convert to pounds
        var startMin = (function () {
          var raw = parseFloat(String(minInput.value || "").replace(/[^\d.]/g, ""));
          if (isNaN(raw)) return minBound;
          return raw / PRICE_FACTOR;
        })();

        var startMax = (function () {
          var raw = parseFloat(String(maxInput.value || "").replace(/[^\d.]/g, ""));
          if (isNaN(raw)) return maxBound;
          return raw / PRICE_FACTOR;
        })();

        // Clamp (pounds)
        startMin = Math.max(minBound, Math.min(startMin, maxBound));
        startMax = Math.max(minBound, Math.min(startMax, maxBound));
        if (startMin > startMax) { var t = startMin; startMin = startMax; startMax = t; }

        // Make the fields user-facing (pounds)
        minInput.step = "1";
        maxInput.step = "1";
        minInput.value = (startMin % 1 === 0) ? String(Math.round(startMin)) : String(startMin.toFixed(2));
        maxInput.value = (startMax % 1 === 0) ? String(Math.round(startMax)) : String(startMax.toFixed(2));

        // Build slider once
        if (!sliderHost.__egNoUiBuilt) {
          sliderHost.__egNoUiBuilt = true;

          if (!window.noUiSlider || typeof window.noUiSlider.create !== "function") return;

          window.noUiSlider.create(sliderHost, {
            start: [startMin, startMax],
            step: 1,
            connect: true,
            range: { min: minBound, max: maxBound }
          });

          sliderHost.noUiSlider.on("update", function (vals) {
            var a = parseFloat(vals[0]);
            var b = parseFloat(vals[1]);
            if (isNaN(a)) a = minBound;
            if (isNaN(b)) b = maxBound;

            minInput.value = String(Math.round(a));
            maxInput.value = String(Math.round(b));
          });

          // When user releases the slider handle: apply filter (URL + render + pills)
          sliderHost.noUiSlider.on("set", function () {
            if (window.__egSuppressPriceUrlWrite) return;

            // reuse the existing apply logic (directly), but we no longer need the button
            var u = new URL(window.location.href);
            var sp = u.searchParams;

            var aPounds = readPoundsOr(minInput, minBound);
            var bPounds = readPoundsOr(maxInput, maxBound);

            // clamp pounds
            aPounds = Math.max(minBound, Math.min(aPounds, maxBound));
            bPounds = Math.max(minBound, Math.min(bPounds, maxBound));
            if (aPounds > bPounds) { var tt = aPounds; aPounds = bPounds; bPounds = tt; }

            // convert to pence for Shopify URL
            var a = Math.round(aPounds * PRICE_FACTOR);
            var b = Math.round(bPounds * PRICE_FACTOR);

            // full-range check in pence
            var isFull = (a <= minBoundCents && b >= maxBoundCents);

            var minName = String(minInput.getAttribute("name") || "");
            var maxName = String(maxInput.getAttribute("name") || "");

            // Prevent duplicate pretty params (min/max) accumulating.
            // If we are about to write long facet keys (filter.v.price.*), remove their pretty aliases first.
            try {
              var pretty = window.EG_URL_PRETTY || {};
              var facetAliases = pretty.facetParamAliases || {};

              var minAlias = minName ? String(facetAliases[minName] || "") : "";
              var maxAlias = maxName ? String(facetAliases[maxName] || "") : "";

              if (minAlias) sp.delete(minAlias);
              if (maxAlias) sp.delete(maxAlias);
            } catch (eAlias) {}

            if (minName) {
              if (isFull) sp.delete(minName);
              else sp.set(minName, String(Math.round(a)));
            }
            if (maxName) {
              if (isFull) sp.delete(maxName);
              else sp.set(maxName, String(Math.round(b)));
            }

            sp.delete("page");

            u.search = sp.toString();
            history.replaceState({}, "", u.toString());
            egApplyPrettyUrlToAddressBar();

            if (root && typeof root.__egClientRenderRefresh === "function") root.__egClientRenderRefresh();
            if (root.__egUpdateAllCounts) root.__egUpdateAllCounts();
            if (root.__egUpdateClearVisibility) root.__egUpdateClearVisibility();
          });

          function applyFromInputs(e) {
            // Apply on Enter, blur, or change
            if (e && e.type === "keydown" && e.key !== "Enter") return;

            var aP = readPoundsOr(minInput, minBound);
            var bP = readPoundsOr(maxInput, maxBound);

            aP = Math.max(minBound, Math.min(aP, maxBound));
            bP = Math.max(minBound, Math.min(bP, maxBound));
            if (aP > bP) { var t0 = aP; aP = bP; bP = t0; }

            // This will trigger the slider "set" handler, which writes URL + refreshes
            if (sliderHost.noUiSlider && typeof sliderHost.noUiSlider.set === "function") {
              sliderHost.noUiSlider.set([aP, bP]);
            }
          }

          minInput.addEventListener("keydown", applyFromInputs);
          maxInput.addEventListener("keydown", applyFromInputs);
          minInput.addEventListener("blur", applyFromInputs);
          maxInput.addEventListener("blur", applyFromInputs);
          minInput.addEventListener("change", applyFromInputs);
          maxInput.addEventListener("change", applyFromInputs);

        } else {
          // If it already exists (e.g. reopening), sync it to current inputs
          if (sliderHost.noUiSlider && typeof sliderHost.noUiSlider.set === "function") {
            sliderHost.noUiSlider.set([startMin, startMax]);
          }
        }
      })(blocks[i]);
    }
  }
}

function bindClearFilters(root) {
  if (!root || root.__egClearBound) return;
  root.__egClearBound = true;

  // Applied pills collapse/expand state
  if (root.__egPillsExpanded === undefined) root.__egPillsExpanded = false;
  var EG_PILLS_MAX = 5; // number of pills to show before "+N more"

    function getBtn() {
      // 1) Prefer the DESKTOP toolbar clear button (even if currently display:none)
      var desktopBtn = document.querySelector(".eg-filter-clear--belowcount[data-eg-clear-filters]");
      if (desktopBtn) return desktopBtn;

      // 2) Next, prefer any clear button outside the mobile sheet header
      var all = document.querySelectorAll("[data-eg-clear-filters]");
      if (!all || !all.length) return null;

      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        // Skip the mobile header one (it lives inside #eg-collection-filters)
        // We want the one in the collection toolbar on desktop.
        if (el && el.classList && el.classList.contains("eg-mobile-filters-clear")) continue;
        return el;
      }

      // 3) Fallback: first one
      return all[0];
    }

    function getPillsHost() {
    var btn = getBtn();
    if (!btn || !btn.parentNode) return null;

    var host = btn.parentNode.querySelector(".eg-applied-pills");
    if (host) return host;

    host = document.createElement("div");
    host.className = "eg-applied-pills";
    btn.parentNode.insertBefore(host, btn);
    return host;
  }

  function syncFilterInputsFromUrl() {
    if (!root) return;

    var sp = new URLSearchParams(window.location.search || "");

    // Shopify facet checkboxes (support pretty alias params too)
    var cfgU = window.EG_URL_PRETTY || {};
    var facetAliasesU = cfgU.facetParamAliases || {};

    function egGetAllFacetBoth(spx, longKey) {
      var out = [];
      var a1 = spx.getAll(longKey);
      for (var i0 = 0; i0 < a1.length; i0++) out.push(a1[i0]);

      var alias = facetAliasesU[longKey];
      if (alias) {
        var a2 = spx.getAll(String(alias));
        for (var j0 = 0; j0 < a2.length; j0++) out.push(a2[j0]);
      }
      return out;
    }

    var facetInputs = root.querySelectorAll('input[type="checkbox"][data-filter-key][name^="filter."]');
    for (var i = 0; i < facetInputs.length; i++) {
      var cb = facetInputs[i];
      var key = cb.name || ""; // long key e.g. filter.p.vendor
      var val = String(cb.value || "");
      var all = egGetAllFacetBoth(sp, key);

      var on = false;
      for (var j = 0; j < all.length; j++) {
        if (String(all[j]) === val) { on = true; break; }
      }
      cb.checked = on;
    }

    // EG tag checkboxes (match using full tags helper)
    if (typeof egBuildEgTagSelectionsFromUrlAsFullTags === "function") {
      try {
        var egSel = egBuildEgTagSelectionsFromUrlAsFullTags(); // Map(groupKey -> Set(fullTag))
        var tagInputs = root.querySelectorAll('input[type="checkbox"][data-eg-kind="tag"][data-eg-tag-group]');
        for (var k = 0; k < tagInputs.length; k++) {
          var t = tagInputs[k];
          var gk = String(t.dataset.egTagGroup || "");
          var set = (egSel && gk && egSel.get) ? egSel.get(gk) : null;

          var ft = String(t.value || "").trim();
          t.checked = !!(set && set.has && set.has(ft));
        }
      } catch (e) {}
    }
  }

  root.__egSyncFilterInputsFromUrl = syncFilterInputsFromUrl;

  function egResetRangeSlidersUiToDefaults() {
    // Only touch the UI widget state. Do NOT touch URL.
    window.__egSuppressRangeUrlWrite = true;
    try {
      var hosts = document.querySelectorAll(".eg-range-wrap[data-eg-range-param]");
      for (var i = 0; i < hosts.length; i++) {
        var host = hosts[i];

        var min0 = parseFloat(host.getAttribute("data-eg-range-min") || "");
        var max0 = parseFloat(host.getAttribute("data-eg-range-max") || "");
        if (isNaN(min0) || isNaN(max0)) continue;

        var minInput = host.querySelector(".eg-range-min");
        var maxInput = host.querySelector(".eg-range-max");
        if (minInput) minInput.value = String(min0);
        if (maxInput) maxInput.value = String(max0);

        var sliderEl = host.querySelector(".eg-range-slider");
        if (sliderEl && sliderEl.noUiSlider && typeof sliderEl.noUiSlider.set === "function") {
          sliderEl.noUiSlider.set([min0, max0]);
        }
      }
    } finally {
      window.__egSuppressRangeUrlWrite = false;
    }
  }

  function labelForParam(k, v) {
    if (k === "filter.v.availability") {
      if (v === "1" || v === "true") return "Availability: In stock";
      if (v === "0" || v === "false") return "Availability: Out of stock";
      return "Availability";
    }

    if (k === "filter.p.vendor") return "Brand: " + v;
    if (k === "filter.p.product_type") return "Type: " + v;

    // Fallback for other Shopify facets
    if (k.indexOf("filter.") === 0) return k + ": " + v;

    // EG tag params are handled separately
    return v;
  }

  function egFormatTagPillLabel(fullTag) {
    var txt = String(fullTag || "").trim();
    if (!txt) return "";

    var group = "";
    var value = "";

    // Preferred convention: Group__Value
    var idx = txt.indexOf("__");
    if (idx !== -1) {
      group = txt.slice(0, idx);
      value = txt.slice(idx + 2);
    } else {
      // Fallback convention: Group_Value
      var idx2 = txt.indexOf("_");
      if (idx2 !== -1) {
        group = txt.slice(0, idx2);
        value = txt.slice(idx2 + 1);
      } else {
        // No delimiter: show as-is
        return txt;
      }
    }

    group = String(group || "").trim();
    value = String(value || "").trim();

    // Clean up group prefixes + separators
    if (group.indexOf("F-") === 0) group = group.slice(2); // "F-Color" -> "Color"
    group = group.replace(/_/g, " ").replace(/-/g, " ").trim();

    // Group label aliases (shorten common groups)
    var gl = group.toLowerCase();
    if (gl === "surface material") group = "Surface";
    else if (gl === "surface type") group = "Type";
    else if (gl === "surface texture") group = "Texture";
    else if (gl === "surface coating") group = "Coating";

    // Optional UK spelling normalisation (only if your group is literally "Color")
    if (group.toLowerCase() === "color") group = "Colour";

    // Clean up value separators
    value = value.replace(/_/g, " ").trim();

    if (!group) return value || txt;
    if (!value) return group;

    return group + ": " + value;
  }

  function egResetPriceSlidersUiToDefaults() {
    window.__egSuppressPriceUrlWrite = true;
    try {
      var roots = document.querySelectorAll("#eg-collection-filters");
      var root = roots && roots[0] ? roots[0] : null;

      var wraps = document.querySelectorAll(".eg-price-range");
      for (var i = 0; i < wraps.length; i++) {
        var wrap = wraps[i];

        var minInput = wrap.querySelector("input[data-eg-price-min]");
        var maxInput = wrap.querySelector("input[data-eg-price-max]");
        var sliderHost = wrap.querySelector(".eg-price-range-slider");

        if (!minInput || !maxInput || !sliderHost || !sliderHost.noUiSlider) continue;

        var minBound = 0;
        var maxBound = parseFloat(String(maxInput.getAttribute("placeholder") || "").replace(/[^\d.]/g, ""));
        if (isNaN(maxBound) || maxBound <= 0) {
          maxBound = parseFloat(String(maxInput.value || "").replace(/[^\d.]/g, ""));
        }
        if (isNaN(maxBound) || maxBound <= 0) continue;

        // reset inputs
        minInput.value = String(minBound);
        maxInput.value = String(maxBound);

        // reset slider UI (suppressed from writing URL)
        sliderHost.noUiSlider.set([minBound, maxBound]);
      }
    } finally {
      window.__egSuppressPriceUrlWrite = false;
    }
  }

function labelForEgSortKey(sk) {
  sk = String(sk || "");
  if (!sk) return "";

  var root = document.getElementById("eg-collection-filters");
  var handle = (root && root.dataset && root.dataset.egCollection) ? String(root.dataset.egCollection) : "";

  var cfg = window.EG_COLLECTION_SORT_CONFIG;
  if (!cfg) return sk;

  var col = (cfg.collections && handle && cfg.collections[handle]) ? cfg.collections[handle] : null;

  // Prefer defaults + extras list (your renderer now shows defaults for all collections)
  var opts = (cfg.defaults && Array.isArray(cfg.defaults.options)) ? cfg.defaults.options : [];
  var colOpts = (col && Array.isArray(col.options)) ? col.options : [];

  // 1) Search defaults first
  for (var i = 0; i < opts.length; i++) {
    if (opts[i] && String(opts[i].key) === sk) return String(opts[i].label || sk);
  }

  // 2) Then search collection options (custom sorts)
  for (var j = 0; j < colOpts.length; j++) {
    if (colOpts[j] && String(colOpts[j].key) === sk) return String(colOpts[j].label || sk);
  }

  return sk;
}

  function buildAppliedPillsFromUrl() {
    var pills = [];
    var sp = new URLSearchParams(window.location.search || "");

    // Shopify facet params (with special handling for price range -> single pill)
    var cfgP = window.EG_URL_PRETTY || {};
    var facetAliasesP = cfgP.facetParamAliases || {};
    function egGet1Both(spx, longKey) {
      var a = spx.get(longKey);
      if (a) return a;
      var alias = facetAliasesP[longKey];
      return alias ? (spx.get(alias) || "") : "";
    }

    var priceGte = egGet1Both(sp, "filter.v.price.gte");
    var priceLte = egGet1Both(sp, "filter.v.price.lte");

    (function addFacetPills() {
      var cfg = window.EG_URL_PRETTY || {};
      var facetAliases = cfg.facetParamAliases || {};

      // reverse: alias -> longKey
      var revFacet = {};
      for (var lk in facetAliases) {
        if (!facetAliases.hasOwnProperty(lk)) continue;
        revFacet[String(facetAliases[lk])] = String(lk);
      }

      sp.forEach(function (val, key) {
        if (!key) return;

        // accept BOTH: "filter.*" and alias keys like "vendor"
        var longKey = null;
        if (key.indexOf("filter.") === 0) longKey = key;
        else if (revFacet[key]) longKey = revFacet[key];
        else return;

        // skip price params here (we add one combined pill below)
        if (longKey === "filter.v.price.gte" || longKey === "filter.v.price.lte") return;

        pills.push({ kind: "facet", key: longKey, value: val, label: labelForParam(longKey, val) });
      });
    })();

    // Add ONE combined price pill (if either bound exists)
    if (priceGte || priceLte) {
      var priceLabel;
      function fmtPenceToPounds(p) {
        var n = parseFloat(String(p || "").replace(/[^\d.]/g, ""));
        if (isNaN(n)) return "";
        var v = n / 100;
        return (v % 1 === 0) ? String(Math.round(v)) : v.toFixed(2);
      }

      var g = fmtPenceToPounds(priceGte);
      var l = fmtPenceToPounds(priceLte);

      if (g && l) priceLabel = "£" + g + "–" + l;
      else if (g) priceLabel = "£" + g + "+";
      else priceLabel = "£0–" + l;

      pills.push({
        kind: "price",
        key: "price",
        value: String(priceGte || "") + "|" + String(priceLte || ""),
        label: priceLabel
      });
    }

    // EG tags (use your helper so labels are the real full tag names, not handles)
    if (typeof egBuildEgTagSelectionsFromUrlAsFullTags === "function") {
      try {
        var egSel = egBuildEgTagSelectionsFromUrlAsFullTags();
        if (egSel && egSel.forEach) {
          egSel.forEach(function (set, groupKey) {
            if (!set || !set.forEach) return;
            set.forEach(function (fullTag) {
              var txt = String(fullTag || "").trim();
              if (!txt) return;

              var label = egFormatTagPillLabel(txt);
              pills.push({ kind: "eg", group: String(groupKey || ""), fullTag: txt, label: label });

            });
          });
        }
      } catch (e) {}
    }

    // Numeric range sliders (EG_NUMERIC_TAG_SLIDERS)
    (function addRangePills() {
      var sliders = window.EG_NUMERIC_TAG_SLIDERS || {};
      for (var k in sliders) {
        if (!sliders.hasOwnProperty(k)) continue;
        var cfg = sliders[k];
        if (!cfg || !cfg.param) continue;

        var param = String(cfg.param);
        var v = String(sp.get(param) || "");
        if (!v) v = String(sp.get(String(k)) || ""); // pretty key e.g. ?length=
        if (!v) continue;

        // Determine if it's actually "active" (not full range)
        var host = document.querySelector('[data-eg-range-param="' + param.replace(/"/g, '\\"') + '"]');
        var unit = (cfg.unit || (host ? (host.getAttribute("data-eg-range-unit") || "") : "")) || "";

        var isActive = true;
        if (host) {
          var min0 = parseFloat(host.getAttribute("data-eg-range-min") || "");
          var max0 = parseFloat(host.getAttribute("data-eg-range-max") || "");
          var mm = (typeof egParseMinMaxFromRangeValue === "function") ? egParseMinMaxFromRangeValue(v) : null;
          var a = mm ? mm.min : NaN;
          var b = mm ? mm.max : NaN;
          if (!isNaN(a) && !isNaN(b) && !isNaN(min0) && !isNaN(max0)) {
            isActive = (a !== min0 || b !== max0);
          }
        }
        if (!isActive) continue;

        // Short labels for range sliders (pills)
        var shortLabelMap = {
          // existing
          length: "L",
          width: "W",
          height: "H",
          thickness: "T",

          // new sliders
          sleeve_length: "Sleeve Length",
          cpi: "DPI",
          p_weight: "Weight",
          p_buttons: "Buttons",
          battery_life: "Battery",
          keys: "Keys",
          cable_length: "Cable Length",
          range: "Range",
          mic_sensitivity: "Mic Sens",
          hp_sensitivity: "HP Sens"
        };

        var rawKey = String(k || "").toLowerCase(); // use the slider key, not cfg.label
        var shortKey = shortLabelMap[rawKey] || rawKey.charAt(0).toUpperCase();

        var labelVal = v.replace("-", "–") + unit;

        pills.push({
          kind: "range",
          key: param,
          value: v,
          label: shortKey + ":" + labelVal
        });
      }
    })();

    // Legacy toggle (optional pill)
    if (sp.get("eg_show_legacy") === "1") {
      pills.push({ kind: "legacy", key: "eg_show_legacy", value: "1", label: "Legacy: shown" });
    }

    // EG sort (eg_sort)
    try {
      var sp2 = new URLSearchParams(window.location.search || "");
      var sk = sp2.get("eg_sort") || "";
      if (sk && sk !== "featured") {
        var sl = labelForEgSortKey(sk);
        pills.push({ kind: "sort", key: "eg_sort", value: sk, label: "Sort: " + sl });
      }
    } catch (eSort) {}

    // De-dupe by a stable key
    var seen = {};
    var out = [];
    for (var i = 0; i < pills.length; i++) {
      var p = pills[i];
      var dk = p.kind + "|" + (p.key || "") + "|" + (p.value || "") + "|" + (p.group || "") + "|" + (p.fullTag || "");
      if (seen[dk]) continue;
      seen[dk] = 1;
      out.push(p);
    }
    return out;
  }

  function renderAppliedPills() {
    var host = getPillsHost();
    if (!host) return;

    var pills = buildAppliedPillsFromUrl();
    host.innerHTML = "";

    if (!pills.length) {
      host.style.display = "none";
      return;
    }

    host.style.display = "";

    // Collapse if too many
    var expanded = !!root.__egPillsExpanded;
    var total = pills.length;
    var showCount = expanded ? total : Math.min(total, EG_PILLS_MAX);

    for (var i = 0; i < showCount; i++) {
      var p = pills[i];

      var b = document.createElement("button");
      b.type = "button";
      b.className = "eg-pill";
      b.setAttribute("data-eg-pill", "1");
      b.setAttribute("data-eg-pill-kind", p.kind);
      if (p.key) b.setAttribute("data-eg-pill-key", p.key);
      if (p.value !== undefined) b.setAttribute("data-eg-pill-value", String(p.value));
      if (p.group) b.setAttribute("data-eg-pill-group", p.group);
      if (p.fullTag) b.setAttribute("data-eg-pill-fulltag", p.fullTag);

      b.innerHTML = '<span class="eg-pill-text"></span><span class="eg-pill-x" aria-hidden="true">×</span>';
      b.querySelector(".eg-pill-text").textContent = p.label;

      // Auto colour by group (same group = same colour, no CSS maintenance)
      (function applyPillColour() {
        // Choose the key we want to colour by:
        // - EG tags: use group key
        // - Shopify facets: use the facet key (vendor/type/availability)
        // - Legacy: its own key
        var key = "";

        if (p.kind === "eg") key = "eg:" + (p.group || "");
        else if (p.kind === "facet") key = "facet:" + (p.key || "");
        else if (p.kind === "legacy") key = "legacy";
        else key = "other";

        // Simple stable hash -> palette index
        var s = String(key || "");
        var h = 0;
        for (var ii = 0; ii < s.length; ii++) {
          h = ((h << 5) - h) + s.charCodeAt(ii);
          h |= 0;
        }
        if (h < 0) h = -h;

        // Palette (keep it short but distinct)
        var palette = [
          { b: "rgba(0,120,255,0.55)", bg: "rgba(0,120,255,0.06)" },
          { b: "rgba(255,140,0,0.55)", bg: "rgba(255,140,0,0.06)" },
          { b: "rgba(140,0,255,0.55)", bg: "rgba(140,0,255,0.06)" },
          { b: "rgba(0,180,120,0.55)", bg: "rgba(0,180,120,0.06)" },
          { b: "rgba(220,0,80,0.55)",  bg: "rgba(220,0,80,0.06)" },
          { b: "rgba(120,120,120,0.55)", bg: "rgba(120,120,120,0.06)" }
        ];

        var pick = palette[h % palette.length];
        b.style.setProperty("--eg-pill-b", pick.b);
        b.style.setProperty("--eg-pill-bg", pick.bg);
      })();

      host.appendChild(b);
    }

    // Add "+N more" / "Show less" control
    if (total > EG_PILLS_MAX) {
      var more = document.createElement("button");
      more.type = "button";
      more.className = "eg-pill eg-pill--more";
      more.setAttribute("data-eg-pill-more", "1");

      if (expanded) {
        more.textContent = "Show less";
      } else {
        more.textContent = "+" + (total - EG_PILLS_MAX) + " more";
      }

      host.appendChild(more);
    }
  }

  function removeOneFromUrl(pillEl) {
    var kind = pillEl.getAttribute("data-eg-pill-kind") || "";
    var u = new URL(window.location.href);
    var sp = u.searchParams;

    if (kind === "facet") {
      var key = pillEl.getAttribute("data-eg-pill-key") || ""; // this is the LONG key we store
      var val = pillEl.getAttribute("data-eg-pill-value") || "";

      var cfg = window.EG_URL_PRETTY || {};
      var facetAliases = cfg.facetParamAliases || {};
      var alias = facetAliases[key] || "";

      // remove only this value (keep other values for same key) across BOTH keys
      var all = [];
      var a1 = sp.getAll(key);
      for (var i = 0; i < a1.length; i++) all.push(a1[i]);

      if (alias) {
        var a2 = sp.getAll(alias);
        for (var j = 0; j < a2.length; j++) all.push(a2[j]);
      }

      sp.delete(key);
      if (alias) sp.delete(alias);

      // write back to LONG key (pretty URL will display alias later)
      for (var x = 0; x < all.length; x++) {
        if (String(all[x]) === String(val)) continue;
        sp.append(key, all[x]);
      }
    }

    if (kind === "price") {
      var cfg = window.EG_URL_PRETTY || {};
      var facetAliases = cfg.facetParamAliases || {};

      var aG = facetAliases["filter.v.price.gte"] || "";
      var aL = facetAliases["filter.v.price.lte"] || "";

      sp.delete("filter.v.price.gte");
      sp.delete("filter.v.price.lte");
      if (aG) sp.delete(aG);
      if (aL) sp.delete(aL);
    }

    if (kind === "range") {
      var key = pillEl.getAttribute("data-eg-pill-key") || "";
      if (key) {
        sp.delete(key); // long (eg_range_length)

        // also delete pretty (length)
        var sliders = window.EG_NUMERIC_TAG_SLIDERS || {};
        for (var rk in sliders) {
          if (!sliders.hasOwnProperty(rk)) continue;
          var sc = sliders[rk];
          if (sc && String(sc.param || "") === String(key)) {
            sp.delete(String(rk));
            break;
          }
        }
      }
      if (key) sp.delete(key);
    }

    if (kind === "legacy") {
      sp.delete("eg_show_legacy");
    }

    if (kind === "eg") {
      var group = pillEl.getAttribute("data-eg-pill-group") || "";
      var fullTag = pillEl.getAttribute("data-eg-pill-fulltag") || "";
      if (!group || !fullTag) return;

      // fullTag -> canonical handle (as stored in the tags map)
      var map = (typeof egBuildTagHandleLookup === "function") ? egBuildTagHandleLookup() : null;
      var handle = map ? (map.get(fullTag) || "") : "";
      if (!handle) return;

      var cfg = window.EG_URL_PRETTY || {};
      var tagAliases = cfg.tagParamAliases || {};
      var paramLong = "eg_tag_" + group;

      // Pretty key is either alias or groupKey (you removed aliases, so it's usually groupKey)
      var paramPretty = tagAliases[group] || group;

      // Read current active handles using the canonical reader (handles suffix vs full forms)
      var next = [];
      try {
        if (typeof egReadActiveEgTagParams === "function") {
          var active = egReadActiveEgTagParams(); // Map(groupKey -> Set(handles))
          var set = active && active.get ? active.get(group) : null;
          if (set && set.forEach) {
            set.forEach(function (h) {
              h = String(h || "").trim();
              if (!h) return;
              if (h === String(handle)) return; // remove the clicked pill
              next.push(h);
            });
          }
        }
      } catch (eRead) {}

      // Delete both param forms, then write back ONLY canonical handles under eg_tag_*
      sp.delete(paramLong);
      sp.delete(paramPretty);

      for (var i = 0; i < next.length; i++) {
        sp.append(paramLong, next[i]);
      }
    }

    if (kind === "sort") {
      sp.delete("eg_sort");
      sp.delete("page");
    }

    // Reset paging
    sp.delete("page");

    u.search = sp.toString();
    history.replaceState({}, "", u.toString());
    egApplyPrettyUrlToAddressBar();
    syncFilterInputsFromUrl();
    if (root && typeof root.__egSyncSortUi === "function") root.__egSyncSortUi();
    if (kind === "price") egResetPriceSlidersUiToDefaults();

    if (kind === "range") egResetRangeSlidersUiToDefaults();

    // Trigger client-side refresh (clientrender owns rerender)
    if (root && typeof root.__egClientRenderRefresh === "function") {
      // Re-render products
      root.__egClientRenderRefresh();

      // Also refresh filter UI state immediately (clear button, has-selection, checked styling, pills)
      if (root.__egUpdateAllCounts) root.__egUpdateAllCounts();
      if (root.__egUpdateClearVisibility) root.__egUpdateClearVisibility();
    } else {
      window.location.href = u.toString();
    }
  }

  function hasAnyActiveFilters() {

    var sp = new URLSearchParams(window.location.search || "");

    // ---- pretty config ----
    var cfg = window.EG_URL_PRETTY || {};
    var facetAliases = cfg.facetParamAliases || {};
    var tagAliases = cfg.tagParamAliases || {};

    // Reverse facet alias -> longKey
    var revFacet = {};
    for (var lk in facetAliases) {
      if (!facetAliases.hasOwnProperty(lk)) continue;
      revFacet[String(facetAliases[lk])] = String(lk);
    }

    // Reverse tag alias -> groupKey
    var revTag = {};
    for (var gk in tagAliases) {
      if (!tagAliases.hasOwnProperty(gk)) continue;
      revTag[String(tagAliases[gk])] = String(gk);
    }

    // ---- detect any active facet/tag params in URL (long OR pretty) ----
    var it = sp.keys();
    var step = it.next();
    while (!step.done) {
      var k = String(step.value || "");
      if (!k) { step = it.next(); continue; }

      // Shopify facets (long + alias)
      if (k.indexOf("filter.") === 0) return true;
      if (revFacet[k]) return true;

      // EG tags (long + alias/groupKey)
      if (k.indexOf("eg_tag_") === 0) return true;
      if (revTag[k]) return true;
      if (tagAliases[k]) return true;

      step = it.next();
    }

    // Numeric slider params (anything configured in EG_NUMERIC_TAG_SLIDERS)
    var sliders = window.EG_NUMERIC_TAG_SLIDERS || {};
    for (var key in sliders) {
      if (!sliders.hasOwnProperty(key)) continue;
      var c = sliders[key];
      if (!c || !c.param) continue;

      var v = String(sp.get(String(c.param)) || "");
      if (!v) v = String(sp.get(String(k)) || ""); // pretty key: length/width/etc
      if (!v) continue;

      // If param exists we treat as active (your UI already suppresses "full range" pills)
      return true;
    }

    // Price (long + alias)
    if (sp.get("filter.v.price.gte") || sp.get("filter.v.price.lte")) return true;
    var aG = facetAliases["filter.v.price.gte"];
    var aL = facetAliases["filter.v.price.lte"];
    if ((aG && sp.get(String(aG))) || (aL && sp.get(String(aL)))) return true;

    // Sort (only active if not default)
    var sk = String(sp.get("eg_sort") || "");
    if (sk && sk !== "featured") return true;

    // Legacy
    if (sp.get("eg_show_legacy") === "1") return true;

    return false;
  }

    function updateMobileAppliedCountBadge() {
    // badge sits on the toolbar open button: "Filter & Sort"
    var openBtn = document.querySelector("[data-eg-mobile-filters-open]");
    if (!openBtn) return;

    // ensure badge element exists
    var badge = openBtn.querySelector(".eg-mobile-filter-badge");
    if (!badge) {
      badge = document.createElement("span");
      badge.className = "eg-mobile-filter-badge";
      openBtn.appendChild(badge);
    }

    // count applied filters via pills (exclude sort)
    var pills = buildAppliedPillsFromUrl();
    var n = 0;
    for (var i = 0; i < pills.length; i++) {
      if (!pills[i] || pills[i].kind === "sort") continue;
      n++;
    }

    badge.textContent = String(n);
    badge.style.display = n > 0 ? "inline-flex" : "none";
  }

  function updateVisibility() {
    const btn = getBtn();
    if (!btn) return;

    const on = hasAnyActiveFilters();
    btn.style.display = on ? "" : "none";

    renderAppliedPills();
    updateMobileAppliedCountBadge();
  }

  root.__egUpdateClearVisibility = updateVisibility;

  if (!window.__egClearClickBound) {
    window.__egClearClickBound = true;

    document.addEventListener("click", (e) => {
      const hit = e.target.closest("[data-eg-clear-filters]");
      if (!hit) return;

      e.preventDefault();

      var u = new URL(window.location.href);
      u.search = "";
      history.replaceState({}, "", u.toString());
      egApplyPrettyUrlToAddressBar();
      syncFilterInputsFromUrl();
      if (root && typeof root.__egSyncSortUi === "function") root.__egSyncSortUi();
      egResetRangeSlidersUiToDefaults();
      egResetPriceSlidersUiToDefaults();

      // Trigger client-side refresh (clientrender owns rerender)
      if (root && typeof root.__egClientRenderRefresh === "function") {
        root.__egClientRenderRefresh();
        if (root.__egUpdateAllCounts) root.__egUpdateAllCounts();
        if (root.__egUpdateClearVisibility) root.__egUpdateClearVisibility();
      } else {
        window.location.href = u.toString();
      }
    });

    document.addEventListener("click", (e) => {
      var more = e.target && e.target.closest ? e.target.closest("[data-eg-pill-more]") : null;
      if (more) {
        e.preventDefault();
        root.__egPillsExpanded = !root.__egPillsExpanded;
        renderAppliedPills();
        return;
      }

      var pill = e.target && e.target.closest ? e.target.closest("[data-eg-pill]") : null;
      if (!pill) return;
      e.preventDefault();
      removeOneFromUrl(pill);
    });

  }

  updateVisibility();
}

function bindPillMoreWrapper(root) {
  if (!root || root.__egPillMoreWrapBound) return;
  root.__egPillMoreWrapBound = true;

  function wrapIfNeeded() {
    var pills = document.querySelector(".eg-applied-pills");
    if (!pills) return;

    var btn = pills.querySelector(".eg-pill.eg-pill--more");
    if (!btn) return;

    // already wrapped
    if (btn.parentNode && btn.parentNode.classList && btn.parentNode.classList.contains("eg-pill-more-wrap")) {
      return;
    }

    // wrap
    var wrap = document.createElement("div");
    wrap.className = "eg-pill-more-wrap";
    btn.parentNode.insertBefore(wrap, btn);
    wrap.appendChild(btn);
  }

  // initial
  wrapIfNeeded();

  // keep it wrapped when pills rerender
  var mo = new MutationObserver(function () {
    wrapIfNeeded();
  });

  mo.observe(document.body, { childList: true, subtree: true });
}

function bindMobileFiltersDrawer(root) {
  if (!root || root.__egMobileDrawerBound) return;
  root.__egMobileDrawerBound = true;

  var openBtn = document.querySelector("[data-eg-mobile-filters-open]");
  var closeBtn = root.querySelector("[data-eg-mobile-filters-close]");
  var backdrop = document.querySelector("[data-eg-mobile-filters-backdrop]");

  if (!openBtn || !closeBtn || !backdrop) return;

  // Insert mobile grid icon toggle (1col / 2col) to the LEFT of Filter & Sort
  var existingSwitch = document.querySelector("[data-eg-mobile-grid-switch]");
  if (!existingSwitch) {
    var wrap = document.createElement("div");
    wrap.setAttribute("data-eg-mobile-grid-switch", "1");
    wrap.className = "eg-mobile-grid-switch";

    var btn2 = document.createElement("button");
    btn2.type = "button";
    btn2.className = "eg-legacy-toggle eg-mobile-grid-btn";
    btn2.setAttribute("data-eg-grid-mode", "2");
    btn2.innerHTML =
      '<svg class="eg-grid-ico" viewBox="0 0 24 24" aria-hidden="true">' +
        '<rect x="4" y="4" width="7" height="7" rx="1"></rect>' +
        '<rect x="13" y="4" width="7" height="7" rx="1"></rect>' +
        '<rect x="4" y="13" width="7" height="7" rx="1"></rect>' +
        '<rect x="13" y="13" width="7" height="7" rx="1"></rect>' +
      '</svg>';

    var btn1 = document.createElement("button");
    btn1.type = "button";
    btn1.className = "eg-legacy-toggle eg-mobile-grid-btn";
    btn1.setAttribute("data-eg-grid-mode", "1");
    btn1.innerHTML =
      '<svg class="eg-grid-ico" viewBox="0 0 24 24" aria-hidden="true">' +
        '<rect x="5" y="5" width="14" height="14" rx="1"></rect>' +
      '</svg>';

    wrap.appendChild(btn2);
    wrap.appendChild(btn1);

    // place immediately BEFORE the Filter & Sort button (left side)
    if (openBtn && openBtn.parentNode) {
      openBtn.parentNode.insertBefore(wrap, openBtn);
    }
  }

  // Wire grid switch (persist in localStorage + active state)
  var sw = document.querySelector("[data-eg-mobile-grid-switch]");
  if (sw && !sw.__egBound) {
    sw.__egBound = true;

    function setMode(mode) {
      mode = String(mode || "2");
      var is1 = (mode === "1");
      document.documentElement.classList.toggle("eg-grid-1col", is1);

      // active highlight via existing .is-on styling
      var b1 = sw.querySelector('[data-eg-grid-mode="1"]');
      var b2 = sw.querySelector('[data-eg-grid-mode="2"]');
      if (b1) b1.classList.toggle("is-on", is1);
      if (b2) b2.classList.toggle("is-on", !is1);

      try { localStorage.setItem("eg_mobile_grid", is1 ? "1" : "2"); } catch (e) {}
    }

    // initial state
    var saved = null;
    try { saved = localStorage.getItem("eg_mobile_grid"); } catch (e) {}
    setMode(saved === "1" ? "1" : "2");

    sw.addEventListener("click", function (e) {
      var t = e && e.target;
      if (!t) return;

      var btn = (t.closest && t.closest("[data-eg-grid-mode]")) ? t.closest("[data-eg-grid-mode]") : null;
      if (!btn) return;

      var mode = btn.getAttribute("data-eg-grid-mode");
      if (!mode) return;

      setMode(mode);
    });
  }

  var prevOverflow = null;

    // If theme scripts preventDefault() on checkbox clicks inside the mobile drawer,
  // the checkbox will never toggle. Detect that and force the toggle + change event.
  root.addEventListener("click", function (e) {
    try {
      if (!window.matchMedia || !window.matchMedia("(max-width: 999px)").matches) return;

      var t = e && e.target;
      if (!t || t.tagName !== "INPUT" || t.type !== "checkbox") return;

      // only for our filter UI
      if (!(t.closest && t.closest("#eg-collection-filters"))) return;

      // If default got prevented by theme, force the toggle ourselves
      if (e.defaultPrevented) {
        t.checked = !t.checked;

        var ev;
        try {
          ev = new Event("change", { bubbles: true });
        } catch (err) {
          ev = document.createEvent("Event");
          ev.initEvent("change", true, false);
        }
        t.dispatchEvent(ev);
      }
    } catch (err2) {}
  }, true);

function openDrawer() {
  if (prevOverflow === null) prevOverflow = document.body.style.overflow || "";
  document.body.style.overflow = "hidden";
  document.documentElement.classList.add("eg-mobile-filters-open");

  if (root.__egSyncFilterInputsFromUrl) root.__egSyncFilterInputsFromUrl();

  try {
    if (window.matchMedia && window.matchMedia("(max-width: 999px)").matches) {

      /* MOVE SORT INTO SCROLL CONTAINER (so it scrolls away) */
      var scroll = root.querySelector(".eg-filterbar-scroll");
      var sortBar = root.querySelector(".eg-filterbar-right");
      if (scroll && sortBar && sortBar.parentNode !== scroll) {
        scroll.insertBefore(sortBar, scroll.firstChild);
      }

      // close any open groups first
      var groups = root.querySelectorAll(".eg-filter-group");
      for (var i = 0; i < groups.length; i++) {
        groups[i].classList.remove("is-open");
        var t0 = groups[i].querySelector(".eg-filter-title");
        if (t0) t0.setAttribute("aria-expanded", "false");
      }

      // open Sort
      var sortGroup = root.querySelector('.eg-filter-group[data-eg-kind="sort"]');
      if (sortGroup) {
        sortGroup.classList.add("is-open");
        var sortTitle = sortGroup.querySelector(".eg-filter-title");
        if (sortTitle) sortTitle.setAttribute("aria-expanded", "true");
      }
    }
  } catch (e) {}
}

  function closeDrawer() {
    document.documentElement.classList.remove("eg-mobile-filters-open");
    if (prevOverflow !== null) {
      document.body.style.overflow = prevOverflow;
      prevOverflow = null;
    }
  }

  openBtn.addEventListener("click", function (e) {
    e.preventDefault();
    openDrawer();
  });

  closeBtn.addEventListener("click", function (e) {
    e.preventDefault();
    closeDrawer();
  });

  backdrop.addEventListener("click", function (e) {
    e.preventDefault();
    closeDrawer();
  });

  document.addEventListener("keydown", function (e) {
    var k = e.key || e.keyCode;
    if (k === "Escape" || k === "Esc" || k === 27) closeDrawer();
  });
}